import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectBlackFridayFlag } from '../../../selectors/filters';
import { changeBlackFridayTypeFilter } from '../../../store/filters/actions';
import { TTypedThunkDispatch } from '../../../types/store';
import { Checkbox } from '@cian/ui-kit';

export const BlackFridayFlagContainer = () => {
  const dispatch = useDispatch<TTypedThunkDispatch>();

  const blackFridayEnabled = useSelector(selectBlackFridayFlag);

  const handleChangeBlackFridayFlag = useEventCallback((_: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    return dispatch(changeBlackFridayTypeFilter(value || undefined));
  });

  return (
    <Checkbox
      value="blackFriday"
      checked={blackFridayEnabled}
      onChange={handleChangeBlackFridayFlag}
      label="Чёрная пятница"
    />
  );
};
